<div class="dialog modal-md">
    <div class="dialog-title">
        <h4>Update Ticket<img src="assets/svg/close-white.svg" alt="close" (click)="close()" ></h4>
    </div>
    <div class="content" [formGroup]="updateTicketForm">
        <h2>Need Assistance? We Are Here To Help!</h2>
        <p>Let us know what area you need help with.</p>
        <div class="custom-form mt-1">
            <label>Ticket Type </label>
            <div class="form-group no-mar">
            <div class="autocomplete" #customTip>
                <input type="text" formControlName="ticketType" disabled>                
            </div>

          </div>
        </div>
        <div class="custom-form mt-1" *ngIf="!techSupport" >
            <label>Quote Number</label>
            <div class="form-group no-mar">
                <div class="autocomplete" #customTip>
                    <input type="text" formControlName="quoteNumber" disabled> 
                </div>
            </div>
        </div>
        <div class="custom-form">
            <label>MESSAGE</label>
            <textarea rows="4" cols="68" formControlName="message" placeholder="Enter message for Ticket"></textarea>
            <span class="form-error-text" style="float: left;" *ngIf="isSubmitted && updateTicketForm.controls.message.invalid">Message Required</span>
        </div>
        <div class="custom-form mt-1">
            <label>STATUS</label>
            <label class="inner">
                <input type="radio" name="status" formControlName="status" value="Open" checked="checked" class="cls-radio">Open
                <span class="checkmarkradio"></span>
            </label>
            <label class="inner">
                <input type="radio" name="status" formControlName="status" value="Closed" class="cls-radio">Closed
                <span class="checkmarkradio"></span>
            </label>

        </div>
        <br>
        <div class="custom-form mt-1">
        <span class="cls-file">
            <a class="upload-btn-wrapper" id="btn">
                <input type="file" formControlName="uploadFile" (change)="onFileSelected($event)" />
                <i class="fa fa-upload"></i>
                <span>&nbsp; Add a File</span>
            </a>  
            <span class="form-error-text" style="float: left;" *ngIf="isSubmitted && updateTicketForm.controls.uploadFile.invalid">File Required</span>        
        </span>
        <span (click)="openDocument()" style="cursor: pointer;" class="cls-download"> <i class="fa fa-download mr-1"></i>{{uploadedFileName}}</span>
       </div>
        <button class="bor-orange" (click)="updateTicket()">Update Ticket</button>
    </div>
</div>

<div *ngIf="showLoader" class="loader">
    <img src="assets/svg/preloader.svg" alt="">
</div>

